import axios from '@/axios.config.js';

class HomeworkService {
    createHomework(cancelToken, classId, sessionId, data) {
        return axios
            .post(`classes/${classId}/sessions/${sessionId}/homeworks`, {
                topic: data.topic,
                description: data.description,
                file_name: data.file_name,
                deadline_date: data.deadline_date,
            }, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateHomework(cancelToken, classId, sessionId, data) {
        return axios
            .patch(`classes/${classId}/sessions/${sessionId}/homeworks/${data.id}`, {
                topic: data.topic,
                description: data.description,
                file_name: data.file_name,
                deadline_date: data.deadline_date,
            }, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteHomework(cancelToken, classId, sessionId, homeworkId) {
        return axios
            .delete(`classes/${classId}/sessions/${sessionId}/homeworks/${homeworkId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    getHomework(cancelToken, classId, sessionId, homeworkId) {
        return axios
            .get(`classes/${classId}/sessions/${sessionId}/homeworks/${homeworkId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listHomeworks(cancelToken, classId, sessionId) {
        return axios
            .get(`classes/${classId}/sessions/${sessionId}/homeworks`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listUserHomeworks(cancelToken) {
        return axios
            .get(`users/me/homeworks`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    submitHomework(cancelToken, classId, sessionId, homeworkId, data) {
        return axios
            .post(`classes/${classId}/sessions/${sessionId}/homeworks/${homeworkId}/submit`, {
                description: data.description,
                file_name: data.file_name,
            }, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    submitted(cancelToken, classId, sessionId, homeworkId) {
        return axios
            .get(`classes/${classId}/sessions/${sessionId}/homeworks/${homeworkId}/submitted`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

}

export default new HomeworkService();